import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('Game2Store')
@observer
export default class GameStep1 extends Component {

    render() {
        return (
            <div className="step-1">
                <h1>Your choices and your results</h1>
                <p>
                    It’s about time we put theory into practice!
                    You are now going to role-play a situation in which you have to engage in the process of negotiation.
                    The teacher will assign a role to each group and keep track of the score.
                    Groups will take turns speaking and are supposed to use the assigned structures.
                    You must reach 100 points to win the game.<br/>
                    This is how you score:<br/>
                    • If your group uses the assigned structure when it’s your turn, you get 10 points.<br/>
                    • If your group doesn’t use the structure or uses it incorrectly,
                    you get no points and the following structure assigned to the other group is worth 15 points.<br/>
                    • If they don’t use their structure or if they use it incorrectly, your next structure is also worth 15 points.<br/>
                    <br/><br/>
                    Are you ready?</p>
            </div>
        )
    }

};


// WEBPACK FOOTER //
// ./src/containers/Game2/Game2Step1.js